import React from 'react';
import { Card } from 'antd';

const LabelPreview = ({ previewUrl }) => {
  return (
    <Card 
      title="面单预览" 
      style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column' 
      }}
      bodyStyle={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: '30px'
      }}
    >
      {previewUrl ? (
        <img 
          src={previewUrl} 
          alt="Label Preview"
          style={{
            width: '100mm',
            height: '150mm',
            objectFit: 'contain',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        />
      ) : (
        <div style={{ 
          color: '#999', 
          fontSize: '16px',
          textAlign: 'center' 
        }}>
          扫描订单后显示面单预览
        </div>
      )}
    </Card>
  );
};

export default LabelPreview;
